import React from 'react';

type Props = {
  text?: string;
};

const LoadingOverlay: React.FC<Props> = ({ text = 'Please wait...' }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center" style={{ zIndex: 9999 }}>
      <div className="absolute inset-0 bg-black/40 pointer-events-auto" />
      <div className="bg-white rounded-lg p-6 flex flex-col items-center gap-4 shadow-lg relative">
        <svg
          className="animate-spin h-10 w-10 text-blue-600"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          ></path>
        </svg>
        <div className="text-sm text-gray-700">{text}</div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
